import type * as Types from '../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type UpdateWebsiteEditorOldPageMutationVariables = Types.Exact<{
  updateEventPagePayload: Types.UpdateEventPagePayload;
  pageId: Types.Scalars['ID'];
}>;

export type UpdateWebsiteEditorOldPageMutation = { __typename?: 'Mutation'; updateEventPage: { __typename?: 'EventPage'; id: string; pageSubTitleV0918?: string | null } };

export const UpdateWebsiteEditorOldPageDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateWebsiteEditorOldPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'updateEventPagePayload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateEventPagePayload' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEventPage' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'pageId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'updateEventPagePayload' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageSubTitleV0918' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateWebsiteEditorOldPageMutationFn = Apollo.MutationFunction<UpdateWebsiteEditorOldPageMutation, UpdateWebsiteEditorOldPageMutationVariables>;

/**
 * __useUpdateWebsiteEditorOldPageMutation__
 *
 * To run a mutation, you first call `useUpdateWebsiteEditorOldPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebsiteEditorOldPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebsiteEditorOldPageMutation, { data, loading, error }] = useUpdateWebsiteEditorOldPageMutation({
 *   variables: {
 *      updateEventPagePayload: // value for 'updateEventPagePayload'
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useUpdateWebsiteEditorOldPageMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWebsiteEditorOldPageMutation, UpdateWebsiteEditorOldPageMutationVariables>,
) {
  return ApolloReactHooks.useMutation<UpdateWebsiteEditorOldPageMutation, UpdateWebsiteEditorOldPageMutationVariables>(UpdateWebsiteEditorOldPageDocument, baseOptions);
}
export type UpdateWebsiteEditorOldPageMutationHookResult = ReturnType<typeof useUpdateWebsiteEditorOldPageMutation>;
export type UpdateWebsiteEditorOldPageMutationResult = Apollo.MutationResult<UpdateWebsiteEditorOldPageMutation>;
export type UpdateWebsiteEditorOldPageMutationOptions = Apollo.BaseMutationOptions<UpdateWebsiteEditorOldPageMutation, UpdateWebsiteEditorOldPageMutationVariables>;
